const BASE_URL = 'https://agora-students.mundoestudiante.cloud';

export const getAlumno = (token)=> {
  return fetch(BASE_URL, {
    method: 'GET',
    headers: { 'Authorization': token },
  })
    .then(res => {
      if (res.ok) return res.json()
      else throw new Error()
    })
    .then(data=> ({ success: true, data }))
    .catch(()=> ({ success: false }))
}

export const uploadCondiciones = ({ token, alumnoId, blob })=> {
  const formData = new FormData();
  formData.append("documento", blob, "documento.pdf");

  return fetch(`${BASE_URL}/alumnos/alumno/condiciones-contratacion?id=${alumnoId}`, {
    method: "PUT",
    body: formData,
    headers: { 'Authorization': token },
  })
    .then(res => {
      if (res.ok) return res.json()
      else throw new Error()
    })
    .then((data) => ({ success: true, data }))
    .catch(() => ({ success: false }))
}

export const uploadRGPD = ({ token, alumnoId, blob })=> {
  const formData = new FormData();
  formData.append("documento", blob, "documento.pdf");

  return fetch(`${BASE_URL}/alumnos/alumno/aceptacion-rgpd?id=${alumnoId}`, {
    method: "PUT",
    body: formData,
    headers: { 'Authorization': token },
  })
    .then(res => {
      if (res.ok) return res.json()
      else throw new Error()
    })
    .then((data) => ({ success: true, data }))
    .catch(() => ({ success: false }))
}

